<div class="table-action-buttons-container display-flex justify-content-end align-items-center">
  <button
    mat-icon-button
    (click)="edit($event)"
    [disabled]="disableEdit || lockFields || !!currentRowReference"
    *ngIf="allowEdit && currentRowReference !== rowReference"
  >
    <app-icon
      [svg]="EIcon.EDIT"
      [iconWidth]="22"
      [iconHeight]="22"
      [matTooltip]="'Edit Row'"
      [iconColor]="disableEdit || lockFields || !!currentRowReference ? EColorPalette.cGray3 : EColorPalette.cGreen3"
    ></app-icon>
  </button>
  <button
    mat-icon-button
    (click)="save($event)"
    *ngIf="allowEdit && currentRowReference === rowReference"
    [disabled]="disableSave || lockFields"
  >
    <app-icon
      [svg]="EIcon.SAVE"
      [iconWidth]="22"
      [iconHeight]="22"
      [iconColor]="disableSave || lockFields ? EColorPalette.cGray3 : EColorPalette.cGreen3"
      [matTooltip]="'Save Row'"
    ></app-icon>
  </button>
  <button
    class="button-icon-background"
    mat-icon-button
    (click)="delete($event)"
    [disabled]="disableDelete || lockFields"
    *ngIf="allowDelete"
  >
    <app-icon
      [svg]="EIcon.TRASH"
      [iconWidth]="22"
      [iconHeight]="22"
      [iconColor]="disableDelete || lockFields ? EColorPalette.cGray3 : EColorPalette.cRed2"
      [matTooltip]="'Delete Row'"
    ></app-icon>
  </button>
</div>
